<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("transferStockLogs") }}</div>
      </div>
      <div class="d-flex align-items-center">
        <div
          v-if="transfer_stock_logs && transfer_stock_logs.length > 0"
          class="mx-2"
        >
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>
    <br />

    <div class="white-wrapper">
      <div class="row col-md-12">
        <div class="col-md-3 mb-1">
          <div class="dropdown-curve-container">
            <label :class="selectedCinema ? 'shift-up' : ''">
              {{ $tc("cinema", 1) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema($event.target.value)"
                    v-on:keydown="onSearchCinema($event.target.value)"
                    v-on:search="onSearchCinema($event.target.value)"
                    @click="
                      searchCinema = '';
                      onSearchCinema($event.target.value);
                    "
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(cinema, cinemaIndex) in cinemas"
                  :key="cinemaIndex"
                  href="#"
                  @click="onSelectCinema(cinema)"
                  >{{ cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <p class="error_message"></p>
          </div>
        </div>

        <div class="col-md-3 mb-1">
          <div class="dropdown-curve-container">
            <label :class="selectedStoreLevel ? 'shift-up' : ''">
              {{ $t("from") }} {{ $t("sm_store_name") }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selectedStoreLevel"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Store"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchStore($event.target.value)"
                    v-on:keydown="onSearchStore($event.target.value)"
                    v-on:search="onSearchStore($event.target.value)"
                    @click="
                      searchStore = '';
                      onSearchStore($event.target.value);
                    "
                    v-model="searchStore"
                  />
                </div>
                <b-dropdown-item
                  v-for="(Item, ItemIndex) in storeManagementsLevels"
                  :key="ItemIndex"
                  href="#"
                  @click="onSelectMainStoreLevel(Item)"
                  >{{ Item.sm_store_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <p class="error_message"></p>
          </div>
        </div>

        <div class="col-md-3 mb-1">
          <div class="dropdown-curve-container">
            <label :class="selectedFinalStore ? 'shift-up' : ''">
              {{ $t("to") }} {{ $t("sm_store_name") }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selectedFinalStore"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Store"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchToStore($event.target.value)"
                    v-on:keydown="onSearchToStore($event.target.value)"
                    v-on:search="onSearchToStore($event.target.value)"
                    @click="
                      searchToStore = '';
                      onSearchToStore($event.target.value);
                    "
                    v-model="searchToStore"
                  />
                </div>
                <b-dropdown-item
                  v-for="(Item, ItemIndex) in finalStoreLevel"
                  :key="ItemIndex"
                  href="#"
                  @click="onSelectStoreLevel(Item)"
                  >{{ Item.sm_store_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <p class="error_message"></p>
          </div>
        </div>

        <div class="col-md-3 mb-1">
          <div class="dropdown-curve-container">
            <label :class="rm_name ? 'shift-up' : ''">
              {{ $tc("rawmaterials", 2) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="rm_name"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Raw Material"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchRawMaterial($event.target.value)"
                    v-on:keydown="onSearchRawMaterial($event.target.value)"
                    v-on:search="onSearchRawMaterial($event.target.value)"
                    @click="
                      searchRawMaterial = '';
                      onSearchRawMaterial($event.target.value);
                    "
                    v-model="searchRawMaterial"
                  />
                </div>
                <b-dropdown-item
                  v-for="(Item, ItemIndex) in rawMaterials"
                  :key="ItemIndex"
                  href="#"
                  @click="onSelectRawMaterial(Item, singleItemIndex)"
                  >{{ Item.rm_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <p class="error_message"></p>
          </div>
        </div>
        <!-- from date -->
        <div class="col-lg-3 col-xl-3 align-self-center md-sm-3 mb-3">
          <div class="input-material">
            <div class="add-datepicker">
              <button
                class="btn-clearDate"
                v-if="from_date"
                v-on:click="onDateChange({ event: null, name: 'fromDate' })"
              >
                ✖
              </button>
              <Datepicker
                :monday-first="true"
                @selected="onDateChange({ event: $event, name: 'fromDate' })"
                ref="programaticOpen"
                :value="from_date"
                v-validate="'required'"
              ></Datepicker>
              <label :class="from_date ? 'active' : ''">{{
                $t("fromdate")
              }}</label>
            </div>
          </div>
        </div>

        <!-- to date -->
        <div class="col-lg-3 col-xl-3 align-self-center mb-3">
          <div class="input-material">
            <div class="add-datepicker">
              <button
                class="btn-clearDate"
                v-if="to_date"
                v-on:click="onDateChange({ event: null, name: 'toDate' })"
              >
                ✖
              </button>
              <Datepicker
                :monday-first="true"
                @selected="onDateChange({ event: $event, name: 'toDate' })"
                ref="programaticOpen"
                :value="to_date"
                v-validate="'required'"
              ></Datepicker>
              <label :class="to_date ? 'active' : ''">{{
                $t("To Date")
              }}</label>
            </div>
          </div>
        </div>

        <div
          class="col-md-6 col-xl-3 mb-1 text-center d-flex justify-content-start"
        >
          <button @click.prevent.stop="onFetch()" class="btn-blue">
            {{ $t("fetch") }} {{ $tc("details", 2) }}
          </button>
        </div>
        <div
          v-if="transfer_stock_logs && transfer_stock_logs.length > 0"
          class="col-md-6 col-xl-3 mb-1 text-center d-flex justify-content-end"
        >
          <div>{{ $t("download") }} as:</div>
          <!-- :href="BASE_URL + vocuerListCSV" -->
          <!-- <a
            v-if="transfer_stock_logs.length > 0"
            :href="transferStockexcel"
            target="_blank"
            title="Download as Excel"
            download
          > -->
          <img
            class="cursor-pointer"
            @click="donwloadExcel"
            src="@/assets/img/icons/excel.svg"
            height="25"
            width="25"
          />
          <!-- </a> -->
        </div>
      </div>

      <!-- LIST VIEW DESIGNATION -->
      <div class="swc-report mt-3">
        <table class="swc-report-table" v-if="listView">
          <thead>
            <tr>
              <th>{{ $tc("status") }}</th>
              <th>{{ $t("transferfromstore") }}</th>
              <th>{{ $t("transfertostore") }}</th>
              <th>{{ $tc("rawmaterials", 2) }}</th>
              <th>{{ $tc("Raw Materials Code") }}</th>
              <th>{{ $tc("Request Code") }}</th>
              <!-- <th>{{ $tc("PO Number") }}</th> -->
              <th>{{ $tc("Qty Requested") }}</th>
              <th>{{ $tc("transfer") }} {{ $tc("quantity", 2) }}</th>
              <th>{{ $t("uom") }}</th>
              <th>{{ $tc("transfer") }} {{ $tc("datetime") }}</th>
              <th>{{ $tc("requested") }} {{ $tc("by") }}</th>
              <th>{{ $tc("transfer") }} {{ $tc("by") }}</th>
            </tr>
          </thead>
          <tbody v-if="transfer_stock_logs && transfer_stock_logs.length > 0">
            <tr
              v-for="(stocks, stocksKey) in transfer_stock_logs"
              :key="stocksKey"
            >
              <td>
                {{
                  stocks.to_cinema_id == null
                    ? "Approved"
                    : stocks.transfer_status
                }}
                <br
                  v-if="
                    stocks.to_cinema_id != null &&
                    stocks.transfer_status == 'Pending'
                  "
                />

                <button
                  v-if="
                    stocks.to_cinema_id != null &&
                    stocks.transfer_status == 'Pending'
                  "
                  @click.prevent.stop="onReject(stocks)"
                  class="mt-2 btn-blue"
                >
                  {{ $t("Reject") }}
                </button>
              </td>
              <td class="text-left">
                {{ stocks.cine_name }} - {{ stocks.transfer_from_store }}
              </td>
              <td class="text-left">
                {{
                  stocks.to_cinema_id == null
                    ? stocks.transfer_to_store
                    : cinemasCopy.filter(
                        (c) => c.cine_id === stocks.to_cinema_id
                      )[0].cine_name || "From Cinema"
                }}
              </td>
              <td class="text-left">{{ stocks.rm_name }}</td>
              <td class="text-left">{{ stocks.rm_code }}</td>
              <td class="text-left">{{ stocks.request_code }}</td>
              <!-- <td class="text-left">
                {{ stocks.po_number | filterNullUndefined }}
              </td> -->
              <td class="text-right">
                {{ stocks.transfer_quantity_requested || 0 }}
              </td>
              <td class="text-right">{{ stocks.transfer_quantity }}</td>
              <td class="text-left">{{ stocks.uom_short_form }}</td>
              <td class="text-left">
                {{ stocks.transfer_date | fulldaydateparse }}
              </td>
              <td class="text-left">{{ stocks.requested_by || '-' }}</td>
              <td class="text-left">{{ stocks.transfer_by }}</td>
            </tr>
            <tr class="w-100" v-if="transfer_stock_logs.length == 0">
              <td colspan="7">
                <h6 class="mb-0">
                  No Records Found
                  <br />
                </h6>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="7">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>

    <b-modal
      id="confirmation"
      title="Reject Stock transfer?"
      hide-footer
      no-close-on-backdrop
    >
      <div class="text-center pb-1">
        <p class="fs-16 mb-2">
          {{ `Are you sure you want to reject stock transfer` }}
        </p>

        <button
          class="btn-outline-blue"
          @click.prevent.stop="cancelStockTransfer"
        >
          Cancel
        </button>
        <span class="mx-1"></span>
        <button
          class="btn btn-danger btn-danger-lg px-4 fs-14"
          @click.prevent.stop="rejectStockTransfer"
        >
          Confirm
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      transferStockexcel: "",
      isRoleID: true,
      isRoleID1: null,
      getitem: "",
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      selectedid: "",
      viewingnumbers: [],
      gridView: false,
      listView: true,
      concession_stocks: [],
      transfer_stock_logs: [],
      selectedStore: "",
      storeLevels: [],
      cinema_id: "",
      selectedCinema: "",
      cinema_address: "",
      searchCinema: "",
      cinemas: [],
      cinemasCopy: [],
      selectedStoreLevel: "",
      store_id: "",
      searchStore: "",
      storeManagementsLevels: [],
      storeManagementsLevelsCopy: [],
      rm_name: "",
      rm_id: "",
      searchRawMaterial: "",
      rawMaterials: [],
      rawMaterialsCopy: [],
      selectedFinalStore: "",
      to_store_id: "",
      searchToStore: "",
      finalStoreLevel: [],
      finalStoreLevelCopy: [],
      transfer_to_reject: "",
      from_date: null,
      to_date: null,
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    this.getCinemas(obj);
    this.getviewingnumber();
  },
  mounted() {},
  destroyed: function () {
    window.removeEventListener("search", this.onSearchCinema);
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    onFetch: function () {
      if (this.selectedCinema) {
        this.getTransferStockLogs();
      } else {
        this.$toasted.show("select cinema");
      }
    },
    donwloadExcel: function () {
      this.getTransferStockLogs("Y");
    },
    onReject(transfer_to_reject) {
      console.log("onReject", { transfer_to_reject });
      this.transfer_to_reject = transfer_to_reject;
      this.$bvModal.show("confirmation");
    },
    onDateChange(payload) {
      console.log("payload", payload);
      if (payload.name == "fromDate") {
        this.from_date = payload.event;
      }
      if (payload.name == "toDate") {
        this.to_date = payload.event;
      }
    },

    cancelStockTransfer() {
      this.transfer_to_reject = "";
      this.$bvModal.hide("confirmation");
    },
    rejectStockTransfer() {
      if (!this.transfer_to_reject.tsl_id) {
        this.$toasted.show("No transfer log id found");
        return;
      }
      let loader = this.$loading.show();
      MasterService.RejectToCinemaStockTransfer(this.transfer_to_reject.tsl_id)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.transfer_stock_logs.forEach((t) => {
              if (t.tsl_id == this.transfer_to_reject.tsl_id)
                t.transfer_status = "Reject";
            });
            this.$forceUpdate();
          }
          this.$toasted.show(data.message);
        })
        .catch(this._CatchError)
        .finally(() => {
          this.$bvModal.hide("confirmation");
          loader.hide();
        });
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },
    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getTransferStockLogs();
      } else {
        this.currentPage = event;
        this.getTransferStockLogs();
      }
    },
    getCinemas: function (cine_id) {
      MasterService.GetCinemas()
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records && data.Records.length > 0) {
            if (cine_id) {
              this.cinemas = data.Records.filter((x) => x.cine_id == cine_id);
            } else {
              this.cinemas = data.Records;
            }
            this.cinemasCopy = data.Records;
            this.cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                this.onSelectCinema(x);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          // this.getTransferStockLogs();
        });
    },
    onSelectCinema: function (cinema) {
      this.selectedCinema = cinema.cine_name;
      this.cinema_address = cinema.cine_address;
      this.cinema_id = cinema.cine_id;
      this.getStoreManagementLevel(cinema.cine_id);
    },
    onSearchCinema: function (value) {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.cinemas = this.cinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.cinemas = this.cinemasCopy;
      }
    },
    getStoreManagementLevel: function (cinema_id) {
      let loader = this.$loading.show();
      this.storeManagementsLevels = [];
      this.selectedStoreLevel = "";

      MasterService.GetStoreManagement({ cine_id: cinema_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records && data.Records.length > 0) {
            if (cinema_id) {
              this.storeManagementsLevels = data.Records.filter(
                (x) => x.cinema_id == cinema_id
              );
            } else {
              this.storeManagementsLevels = data.Records;
            }
            this.storeManagementsLevelsCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        }); //message
    },
    onSelectMainStoreLevel: function (store) {
      this.store_id = store.sm_id;
      this.selectedStoreLevel = store.sm_store_name;

      this.selectedFinalStore = "";
      this.to_store_id = "";
      this.finalStoreLevel = [];
      this.finalStoreLevelCopy = [];
      this.finalStoreLevel = this.storeManagementsLevels.filter((x) => {
        return x.sm_id !== store.sm_id;
      });
      this.finalStoreLevelCopy = this.finalStoreLevel;

      this.getStoreBasedQuantity(store);
    },
    onSearchStore: function (value) {
      if (this.searchStore && this.searchStore.length > 0) {
        this.storeManagementsLevels = this.storeManagementsLevelsCopy.filter(
          (x) => {
            if (
              x.sm_store_name
                .toLowerCase()
                .includes(this.searchStore.toLowerCase())
            ) {
              return x;
            }
          }
        );
      } else {
        this.storeManagementsLevels = this.storeManagementsLevelsCopy;
      }
    },
    getStoreBasedQuantity: function (store) {
      let loader = this.$loading.show();

      this.rawMaterials = [];
      let payload = {
        sm_id: store.sm_id,
      };
      PosFnbService.GetStoreBasedQuantity(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records && data.Records.length > 0) {
            this.rawMaterials = data.Records;
            this.rawMaterialsCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        }); //message
    },
    onSelectRawMaterial: function (rawmaterial, index) {
      this.rm_name = rawmaterial.rm_name;
      this.rm_id = rawmaterial.rm_id;
    },
    onSearchRawMaterial: function (value) {
      if (this.searchRawMaterial && this.searchRawMaterial.length > 0) {
        this.rawMaterials = this.rawMaterialsCopy.filter((x) => {
          if (
            x.rm_name
              .toLowerCase()
              .includes(this.searchRawMaterial.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.rawMaterials = this.rawMaterialsCopy;
      }
    },
    onSelectStoreLevel: function (store) {
      this.selectedFinalStore = store.sm_store_name;
      this.to_store_id = store.sm_id;
    },
    onSearchToStore: function (value) {
      if (this.searchToStore && this.searchToStore.length > 0) {
        this.finalStoreLevel = this.finalStoreLevelCopy.filter((x) => {
          if (
            x.sm_store_name
              .toLowerCase()
              .includes(this.searchToStore.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.finalStoreLevel = this.finalStoreLevelCopy;
      }
    },
    getTransferStockLogs: function (isExcel = "N") {
      if(!this.cinema_id) {
        return this.$toasted.show('Please Select Cinema')
      }

      if(this.from_date > this.to_date){
        return this.$toasted.show('The "From Date" should not be later than the "To Date".')
      }

      let loader = this.$loading.show();
      if (isExcel == "N") {
        this.transfer_stock_logs = [];
      }
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        cinema_id: this.cinema_id,
        from_store_id: this.store_id,
        to_store_id: this.to_store_id,
        raw_material_id: this.rm_id,
        cinema_name: this.selectedCinema,
        cinema_address: this.cinema_address,
        from_date: this.from_date,
        to_date: this.to_date,
        isExcel,
      };

      PosFnbService.TransferStockLogs(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records && data.Records.length > 0) {
            this.transfer_stock_logs = data.Records;
            this.transferStockexcel = data.excelPath;
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
              this.selectedvalue = this.perPage;
            } else if (data.totalRows) {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
            if (data.excelPath && isExcel == "Y") {
              window.open(data.excelPath, "_blank");
            }
          } else {
            this.transfer_stock_logs = [];
            this.$toasted.show(data.message);
            this.rows = 0;
            this.selectedvalue = "0";
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },
    /* eslint-disable */

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
    // onClickEdit: function(){
    //   this.$router.push({ path: 'master/editaggregators' })
    // }
  },
};
</script>

<style scoped>
.swc-report-table th,
.swc-report-table td {
  border: 1px solid #c7c6c6;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/TransferStocks/transferStocksLogs.vue